module.exports = __webpack_public_path__ + "static/media/16jordanpropart.2d19f6be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/16jordanpropart.png
// module id = 115
// module chunks = 0